import { memo } from 'react';

type SelectEmptyOptionProps = {
  noOptionsText?: string;
};

export const SelectEmptyOption = memo(({ noOptionsText }: SelectEmptyOptionProps) => {
  return (
    <li className="flex w-full items-center justify-center">
      <div className="font-medium text-12 text-grey-10">{noOptionsText || 'No options'}</div>
    </li>
  );
});

SelectEmptyOption.displayName = 'SelectEmptyOption';
